<template>
	<div>
		<div id="captcha-button">
			<div class="captcha-con hov" v-show="!isActive">
				<div class="img-box scla">
					<img class="vervy-icon" src="https://xl-online.oss-cn-hangzhou.aliyuncs.com/BUG/vervy-icon.png" alt="" />
				</div>
				<div class="text success">点击按钮开启智能验证</div>
			</div>

			<div class="captcha-con success" v-show="isActive">
				<div class="img-box">
					<img class="vervy-icon" src="https://xl-online.oss-cn-hangzhou.aliyuncs.com/BUG/vervy-icon-active.png" alt="" />
				</div>
				<div class="text success">验证成功</div>
			</div>
		</div>
		<div id="captcha-element"></div>
	</div>
</template>

<script>
export default {
	props: {},
	data() {
		return {
			captcha: null,
			captchaButton: null,
			isActive: false,
			popupId:''
		};
	},
	mounted() {
		this.captchaButton = document.getElementById('captcha-button');

		window.initAliyunCaptcha({
			SceneId: 'vkw6dmck', // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
			prefix: 'stc17n', // 身份标。开通阿里云验证码2.0后，您可以在控制台概览页面的实例基本信息卡片区域，获取身份标
			mode: 'popup', // 验证码模式。popup表示要集成的验证码模式为弹出式。无需修改
			element: '#captcha-element', // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
			button: '#captcha-button', // 触发验证码弹窗的元素。button表示单击登录按钮后，触发captchaVerifyCallback函数。您可以根据实际使用的元素修改element的值
			captchaVerifyCallback: this.captchaVerifyCallback, // 业务请求(带验证码校验)回调函数，无需修改
			onBizResultCallback: this.onBizResultCallback, // 业务请求结果回调函数，无需修改
			getInstance: this.getInstance, // 绑定验证码实例函数，无需修改
			slideStyle: {
				width: 360,
				height: 40
			}, // 滑块验证码样式，支持自定义宽度和高度，单位为px。其中，width最小值为320 px
			language: 'cn' // 验证码语言类型，支持简体中文（cn）、繁体中文（tw）、英文（en）
		});
	},
	beforeUnmount() {
		this.captchaButton = null;

		// 必须删除相关元素，否则再次mount多次调用 initAliyunCaptcha 会导致多次回调 captchaVerifyCallback
		document.getElementById('aliyunCaptcha-mask')?.remove();
		document.getElementById('aliyunCaptcha-window-popup')?.remove();
	},
	methods: {
		clear() {
			this.isActive = false;
		},
		getInstance(instance) {
			this.captcha = instance;
		},
		async captchaVerifyCallback(captchaVerifyParam) {
			const res = await this.$api.postAuthenticateSig({ captchaVerifyParam });
			console.log(res);
			let result = {
				captchaResult: false,
				bizResult: true,
				captchaVerifyParam,
				popupId:this.popupId
			};
			if (res.captchaVerifyResult === true) {
				result.captchaResult = true;
				this.isActive = true;
			}
			console.log(result);
			this.$emit('verify', result);
			return result;
		},
		// 验证通过后调用
		onBizResultCallback() {
			console.log('onBizResultCallback');
		},
		// 弹出验证框，popupId为组件id，用于支持验证通过后继续触发业务逻辑
		popup(popupId) {
			this.popupId = popupId;
			this.captchaButton.click();
		}
	}
};
</script>

<style>
#captcha-button {
	width: 100%;
}
.captcha-con {
	width: 100%;
	height: 44px;
}
.captcha-con{
	display: flex;
	align-items: center;
	box-sizing: border-box;
	border: 1px solid #DDDDDD;
	padding: 0 10px;
}
.img-box{
	display: flex;
	align-items: center;
	margin-right: 24px;
}
.scla{
	animation:sc .7s ease infinite forwards;
}
@keyframes sc {
	0%{
		transform: scale(1);
	}
	25%{
		transform: scale(0.75);
	}
	50{
		transform: scale(0.5);
	}
	50{
		transform: scale(0.75);
	}
	100%{
		transform: scale(1);
	}
}
.captcha-con.success{
	border: 1px solid #00DE76;
}
.vervy-icon{
	width: 36px;
	height: 36px;
}
.hov:hover {
	box-shadow: 0px 0px 8px 0px rgba(0, 222, 118, 0.3);
}
#aliyunCaptcha-mask {
	z-index: 98;
}
#aliyunCaptcha-window-popup {
	z-index: 99;
}
</style>
